module.exports = __webpack_public_path__ + "img/MITRealEstateTechnology_WorkshopRecaps-37.49970f21.jpg";